export { default as component } from "../../../../src/routes/[prefix]/(feature)/order-outstanding/+page.svelte";